export const FIRM = {
 
  phone: '0300-9439703',
  email: 'info@sqamer.com',
  address: 'Office No. 1, Ali Centre, 2nd Floor, Lodhi Arcade, Near ICMA College, 42-Ferozepur Road, Lahore, Pakistan', 
  established: '2002',
  logo: '/images/logo.png',
  footer_logo:'/images/footer.png'
};

export const STATS = [
  { num: '2000+', label: 'Satisfied Clients' },
  { num: '1000+', label: 'NTN Registered' },
  { num: '20+',   label: 'Years Experience' },
  { num: '99%',   label: 'Success Rate' },
];

export const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about-us' },
  {label: 'Blog' , path: '/blog'},
  {
    label: 'Tax Matters',
    children: [
      { label: 'Tax Registration (NTN)', path: '/tax-registration' },
      { label: 'Income Tax Returns',     path: '/annual-tax-return' },
      { label: 'Sales Tax Returns',      path: '/sales-tax-return' },
      { label: 'Tax Appeals',            path: '/tax-appeals' },
      { label: 'Tax Refunds',            path: '/tax-refund-in-pakistan' },
      { label: 'Active Tax Filer (ATL)', path: '/active-tax-filer-in-pakistan' },
    ],
  },
  {
    label: 'Legal Matters',
    children: [
      { label: 'Criminal Case',  path: '/criminal-case' },
      { label: 'Civil Case',     path: '/civil-case' },
      { label: 'FIA Case',       path: '/fia-case' },
      { label: 'Banking Case',   path: '/banking-case' },
      { label: 'Family Case',    path: '/family-case' },
      { label: 'Property Case',  path: '/property-case' },
    ],
  },
  {
    label: 'Corporate',
    children: [
      { label: 'Company Registration', path: '/company-registration' },
      { label: 'SECP Matters',         path: '/secp-matters' },
      { label: 'Firm Registration',    path: '/firm-registration' },
      { label: 'NGO Registration',     path: '/ngo-society-registration' },
      { label: 'PEC Registration',     path: '/pec-registration-in-pakistan' },
      { label: 'Chamber of Commerce',  path: '/chamber-of-commerce-registration-in-pakistan' },
     { label: 'SoftwareHouse Registration', path: '/software-house-registration' }  
      ],
  },
  {
    label: 'Immigration',
    children: [
       { label:'Study Visa',            path: '/study-visa-consultants' },
      { label: 'Skilled Immigration',   path: '/skilled-immigration-experts-in-pakistan' },
      { label: 'Business Immigration',  path: '/business-immigration-consultant-in-pakistan' },
      { label: 'Visa Refusal Appeals',  path: '/visa-appeals' },
      { label: 'Visa File Preparation', path: '/visa-file-preparation' },
    ],
  },
  { label: 'Contact Us', path: '/contact', cta: true },
];

export const SERVICES_HOME = [
  { icon: '🏢', title: 'Company Registration',       desc: 'Register your private or public limited company with SECP quickly and hassle-free.',                path: '/company-registration', color: 'bg-blue-50 border-blue-200 hover:bg-blue-100' },
  { icon: '🤝', title: 'Partnership Firm',            desc: 'Register your partnership firm with full legal documentation and compliance support.',            path: '/firm-registration', color: 'bg-purple-50 border-purple-200 hover:bg-purple-100' },
  { icon: '🧾', title: 'Tax Filing',                  desc: 'Income tax, sales tax returns, NTN registration, FBR compliance, and tax appeals.',              path: '/ntn-registration',           color: 'bg-emerald-50 border-emerald-200 hover:bg-emerald-100' },
  { icon: '🌐', title: 'Import/Export License',       desc: 'Complete assistance for import/export licenses, trade registrations, and customs compliance.',    path: '/contact',                        color: 'bg-orange-50 border-orange-200 hover:bg-orange-100' },
  { icon: '📞', title: 'Call Center License',         desc: 'PTA-approved call center license registration with full documentation and regulatory support.',   path: '/contact',                        color: 'bg-rose-50 border-rose-200 hover:bg-rose-100' },
  { icon: '💻', title: 'Software House Registration', desc: 'Register your software house with PSEB and SECP for tax benefits and official recognition.',      path: '/software-house-registration',                        color: 'bg-amber-50 border-amber-200 hover:bg-amber-100' },
  { icon: '✈️', title: 'Travel Agency License',       desc: 'Get your IATA-approved travel agency license with complete documentation and TCPB registration.', path: '/contact',                        color: 'bg-sky-50 border-sky-200 hover:bg-sky-100' },
  { icon: '🏛️', title: 'Chamber of Commerce',        desc: 'Membership registration with Lahore Chamber of Commerce & Industry and other chambers.',         path: '/chamber-of-commerce-registration-in-pakistan',  color: 'bg-teal-50 border-teal-200 hover:bg-teal-100' },
];

export const TAX_SIDEBAR = [
  { label: 'Tax Registration (NTN)', path: '/ntn-registration' },
  { label: 'Income Tax Returns',     path: '/income-tax-return' },
  { label: 'Sales Tax Returns',      path: '/sales-tax-return' },
  { label: 'Tax Appeals',            path: '/tax-appeals' },
  { label: 'Tax Refund',             path: '/tax-refund-in-pakistan' },
  { label: 'Active Tax Filer',       path: '/active-tax-filer' },
];

export const LEGAL_SIDEBAR = [
  { label: 'Criminal Case', path: '/criminal-case' },
  { label: 'Civil Case',    path: '/civil-case' },
  { label: 'Banking Case',  path: '/banking-case' },
  { label: 'Family Case',   path: '/family-case' },
  { label: 'Property Case', path: '/property-case' },
  { label: 'FIA Case',      path: '/fia-case' },
];

export const CORP_SIDEBAR = [
  
  { label: 'Company Registration', path: '/company-registration' },
  { label: 'SECP Matters',         path: '/secp-matters' },
  { label: 'Firm Registration',    path: '/firm-registration' },
  { label: 'NGO Registration',     path: '/ngo-society-registration' },
  { label: 'PEC Registration',     path: '/pec-registration-in-pakistan' },
  { label: 'Chamber of Commerce',  path: '/chamber-of-commerce-registration-in-pakistan' },
  { label: 'Software House Registration', path: '/software-house-registration' }
];


export const IMM_SIDEBAR = [
   { label: 'Study Visa',            path: '/study-visa' },
  { label: 'Visa Appeals',          path: '/visa-appeals' },
  { label: 'Visa File Preparation', path: '/visa-file-preparation' },
  { label: 'Skilled Immigration',   path: '/skilled-immigration' },
  { label: 'Business Immigration',  path: '/business-immigration-consultant-in-pakistan' },
 
];

export const TESTIMONIALS = [
  { name: 'Mian Faizan', title: 'Director, Softech byte.', initial: 'M', text: 'S.Qamer & Co. registered my company with SECP within just 3 days. Shahzada Qamer fulfilled his commitment and the entire process was smooth. Strongly recommended!' },
  { name: 'Ahmed Raza', title: 'Business Owner, Lahore',        initial: 'A', text: 'Excellent tax filing service. They handled my income tax return and got me registered as an active filer within days. Their FBR knowledge is exceptional.' },
  { name: 'Sara Khan',  title: 'Student, Lahore',               initial: 'S', text: 'I got my study visa approved for Australia thanks to S.Qamer & Co.\'s immigration team. Their visa file preparation was thorough and professional. 100% recommend!' },
];

export const WHY_US = [
  { icon: '🎓', title: 'Certified Professionals',   desc: 'FBR-registered practitioners, and Immigration law experts.' },
  { icon: '💰', title: 'Transparent Pricing',        desc: 'No hidden fees. Clear fee structures upfront and detailed engagement letters before we begin.' },
  { icon: '⚡', title: 'Fast Turnaround',            desc: 'Streamlined processes ensure your filings and registrations are completed on time, every time.' },
  { icon: '🤝', title: 'Dedicated Client Support',   desc: 'A dedicated consultant handles your case from start to finish — always available for updates.' },
  { icon: '🔒', title: 'Confidential & Secure',      desc: 'Your personal and financial information is handled with the highest professional discretion.' },
];
